// extracted by mini-css-extract-plugin
export var controls = "carouselControls-module--controls--s54Cq";
export var icon = "carouselControls-module--icon--+BoGg";
export var inactive = "carouselControls-module--inactive--oPaKl";